(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_hero-image-slider"] && !Shopify.designMode) return;
  try {
    const slider = document.querySelector('#hero-slider');
const slides = slider.querySelectorAll(':scope > div');

let index = 0;

function updateSlides() {
  slides.forEach(slide => {
    slide.classList.remove('prev', 'active', 'next');
  });

  const prevIndex = (index - 1 + slides.length) % slides.length;
  const nextIndex = (index + 1) % slides.length;

  slides[prevIndex].classList.add('prev');
  slides[index].classList.add('active');
  slides[nextIndex].classList.add('next');
}

updateSlides();

setInterval(() => {
  index = (index + 1) % slides.length;
  updateSlides();
}, 6000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_hero-text-slider"] && !Shopify.designMode) return;
  try {
    const parent = document.querySelector('#stagger');
const items = parent.querySelectorAll(':scope > div');

let index = 0;
function showItem(i) {
  items.forEach(el => el.classList.remove('active'));
  items[i].classList.add('active');
}

// démarrage
showItem(index);

// boucle toutes les 3 secondes
setInterval(() => {
  index = (index + 1) % items.length;
  showItem(index);
}, 6000);

document.querySelectorAll('.Hero_Text_Slider').forEach(section => {
  const allBlocks = section.querySelectorAll('.Hero_Page_Main_Container');
  
  // Trouver le bloc Hero_Text_Slider qui doit contenir les points
  allBlocks.forEach(slider => {
    const dotsContainer = slider.querySelector('.Hero_Active_Slide');

    // Créer un point pour chaque bloc dans la section
    allBlocks.forEach((_, i) => {
      const dot = document.createElement('span');
      if (i === 0) dot.classList.add('active');
      dotsContainer.appendChild(dot);
    });
  });

  let index = 0;
  function setActive(i) {
    allBlocks.forEach(block => block.classList.remove('active'));
    allBlocks[i].classList.add('active');

    // Mettre à jour tous les indicateurs
    section.querySelectorAll('.Hero_Active_Slide').forEach(container => {
      const dots = container.querySelectorAll('span');
      dots.forEach(dot => dot.classList.remove('active'));
      if (dots[i]) dots[i].classList.add('active');
    });
  }

  // Premier affichage
  setActive(index);

  // Boucle automatique
  setInterval(() => {
    index = (index + 1) % allBlocks.length;
    setActive(index);
  }, 6000);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    const collapseButtons = document.querySelectorAll('.Filter__Collapse__Button[data-collapse-target]');
  collapseButtons.forEach(btn => {
    const targetId = btn.getAttribute('data-collapse-target');
    const target = document.getElementById(targetId);
    if (!target) return;

    const collectionWrapper = btn.closest('.collection-wrapper');
    const facetsInner = target.querySelector('.facets'); // la div interne

    btn.setAttribute('aria-expanded', 'false');
    target.classList.remove('is-open');

    btn.addEventListener('click', () => {
      const isOpen = target.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      // toggle vertical sur le wrapper
      target.classList.toggle('facets-block-wrapper--vertical', isOpen);
      collectionWrapper?.classList.toggle('facets--sidebar-open', isOpen);

      // toggle vertical sur la div interne
      if (facetsInner) {
        if (isOpen) {
          facetsInner.classList.remove('facets--collapse');
          facetsInner.classList.add('facets--vertical');
        } else {
          facetsInner.classList.remove('facets--vertical');
          facetsInner.classList.add('facets--collapse');
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
